/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var fetch = MoyaContainer.get('core.fetch');
    MoyaComponents.register('flytibokun.lang', function (el) {
        var currentLang = localStorage.getItem('flytibokunLang');
        if (currentLang === null) {
            currentLang = 'is';
        }
        var config = {
            rootElement: el,
            step: el.dataset.step,
            updateUrl: el.dataset.updateUrl,
            langToggleButton: el.querySelector('button.langToggleButton'),
            currentLang: currentLang,
        };
        var dude = new FlytibokunLang(config);
        dude.run();
    });
    var FlytibokunLang = /** @class */ (function () {
        function FlytibokunLang(config) {
            this.rootElement = config.rootElement;
            this.langToggleButton = config.langToggleButton;
            this.currentLang = config.currentLang;
            this.step = config.step;
            this.updateUrl = config.updateUrl;
        }
        FlytibokunLang.prototype.run = function () {
            var _this = this;
            this.updateCurrentLang();
            if (this.step === 'first') {
                util.delegate(this.langToggleButton, 'click', '.langToggleButton', function (e) {
                    _this.toggleCurrentLang();
                    _this.updateTexts();
                });
            }
            if (this.step === 'second' || this.step === 'third') {
                this.updateTexts();
            }
        };
        FlytibokunLang.prototype.toggleCurrentLang = function () {
            if (this.currentLang === 'is') {
                this.langToggleButton.classList.add('lang_en');
                localStorage.setItem('flytibokunLang', 'en');
                this.currentLang = 'en';
                this.updateSession();
                return;
            }
            this.langToggleButton.classList.remove('lang_en');
            this.currentLang = 'is';
            localStorage.setItem('flytibokunLang', 'is');
            this.updateSession();
        };
        FlytibokunLang.prototype.updateTexts = function () {
            var _this = this;
            var selector = 'data-lang-' + this.currentLang;
            this.rootElement.querySelectorAll('[' + selector + ']').forEach(function (elm) {
                var text = elm.dataset.langEn;
                if (_this.currentLang === 'is') {
                    text = elm.dataset.langIs;
                }
                if (elm instanceof HTMLSelectElement) {
                    _this.updateSelectElm(elm, text);
                }
                else if (elm instanceof HTMLInputElement) {
                    _this.updateInputElm(elm, text);
                }
                else {
                    elm.innerHTML = text;
                }
            });
        };
        FlytibokunLang.prototype.updateSelectElm = function (elm, text) {
            if (this.currentLang === 'is') {
                if (elm.dataset.firstOptionIs !== undefined) {
                    elm.firstElementChild.innerHTML = elm.dataset.firstOptionIs;
                    elm.firstElementChild.setAttribute('label', elm.dataset.firstOptionIs);
                }
                if (elm.dataset.optionsIs) {
                    var data = JSON.parse(elm.dataset.optionsIs);
                    elm.length = 0;
                    for (var key in data) {
                        var option = document.createElement('option');
                        option.text = data[key];
                        option.value = key;
                        elm.add(option);
                    }
                }
            }
            if (this.currentLang === 'en') {
                if (elm.dataset.firstOptionEn !== undefined) {
                    elm.firstElementChild.innerHTML = elm.dataset.firstOptionEn;
                    elm.firstElementChild.setAttribute('label', elm.dataset.firstOptionEn);
                }
                if (elm.dataset.optionsEn) {
                    var data = JSON.parse(elm.dataset.optionsEn);
                    elm.length = 0;
                    for (var key in data) {
                        var option = document.createElement('option');
                        option.text = data[key];
                        option.value = key;
                        elm.add(option);
                    }
                }
            }
            elm.parentElement.parentElement.firstElementChild.innerHTML = text;
        };
        FlytibokunLang.prototype.updateInputElm = function (elm, text) {
            elm.parentElement.parentElement.firstElementChild.innerHTML = text;
        };
        FlytibokunLang.prototype.updateSession = function () {
            var formData = new FormData();
            formData.append('lang', this.currentLang);
            fetch.fetchJson(this.updateUrl, 'POST', formData).then(function (res) {
                console.log(res);
            });
        };
        FlytibokunLang.prototype.updateCurrentLang = function () {
            this.updateTexts();
        };
        return FlytibokunLang;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
